/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { BASE_TITLE, BASENAME } from '../../../config/constant';
import useAuth from '../../../hooks/useAuth';
import userService from '../../../services/user-service';

const Breadcrumb = () => {
  const { user } = useAuth();
  const cmpId = JSON.parse(localStorage.getItem('cmpId'));
  const sst_Id = JSON.parse(localStorage.getItem('sstId'));
  const accessId = JSON.parse(localStorage.getItem('accessId'));
  const [items, setItems] = useState([]);
  const [main, setMain] = useState([]);
  const [item, setItem] = useState([]);

  const fetchMenuLevels = () => {
    var data = { sstId: sst_Id, accessId: accessId, cmpId: cmpId }
    userService
      .getMenuLevels(data)
      .then((response) => {
        setItems(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const genSchoolDefaults = async (cmpId) => {
    const data = {
      cmpId: cmpId,
      sstId: 500
    };
    userService.generateSchoolDefaults(data)
      .then((res) => {
        console.log('DEFAULTS GENERATED');
      })
      .catch((e) => {
        console.log('DEFAULTS NOT GENERATED');
      });
  };

  const fetchTeacherCode = async (sspUsername, cmpId) => {
      const data = {
        sspUsername,
        cmpId
      }
      console.log(data);
      userService.getEmployeeDetailsByUsernameAndCmpId(data)
        .then((res) => {
          localStorage.setItem('teacherCode', JSON.stringify(res.data[0].employeeCode));
           console.log(res);
        })
        .catch((e) => {
          console.log(e);
        });
    };

  // console.log(items)
  // useEffect(() => {
  //   if (!cmpId) return;

  //   genSchoolDefaults(cmpId)
  //   if (user) { fetchMenuLevels(user.id) } else return;

  // }, [cmpId])

  useEffect(() => {
    if (!cmpId) return;
    
      genSchoolDefaults(cmpId);

    const timer = setTimeout(() => {
      genSchoolDefaults(cmpId);
      fetchTeacherCode(user?.username, cmpId);
    }, 1000);

    if (user) {
      fetchMenuLevels(user.id);
    }

    return () => clearTimeout(timer);
  }, [cmpId, user]);

  useEffect(() => {
    items.map((item, index) => {
      if (item.type && item.type === 'group') {
        getCollapse(item, index);
      }
      return false;
    });
  });

  const getCollapse = (item) => {
    if (item.children) {
      item.children.filter((collapse) => {
        if (collapse.type === 'collapse') {
          getCollapse(collapse);
        } else if (collapse.type && collapse.type === 'item') {
          if (document.location.pathname === BASENAME + collapse.url) {
            setMain(item);
            setItem(collapse);
          }
        }
        return false;
      });
    }
  };

  let mainContent, itemContent;
  let breadcrumbContent = '';
  let title = '';

  if (main && main.type === 'collapse') {
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to="#">{main.title}</Link>
      </ListGroup.Item>
    );
  }

  if (item && item.type === 'item') {
    title = item.title;
    itemContent = (
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to="#">{title}</Link>
      </ListGroup.Item>
    );

    if (item.breadcrumbs === 'true') {
      breadcrumbContent = (
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="page-header-title">
                  <h5 className="m-b-10">{title}</h5>
                </div>
                <ListGroup as="ul" bsPrefix=" " className="breadcrumb">
                  <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
                    <Link to="/">
                      <i className="feather icon-home" />
                    </Link>
                  </ListGroup.Item>
                  {mainContent}
                  {itemContent}
                </ListGroup>
              </div>
            </div>
          </div>
        </div>
      );
    }

    document.title = title + BASE_TITLE;
  }

  return <React.Fragment>{breadcrumbContent}</React.Fragment>;
};

export default Breadcrumb;
